/* eslint-disable @typescript-eslint/no-explicit-any */
import { Stack, Typography } from '@mui/material';
import { RootState } from 'packages/blu-booking/src/store';
import { Scheduler } from './UI/Scheduler';
import { memo, useMemo } from 'react';
import { useSchedulerData } from './hooks/useSchedulerData';
import { useSelector } from 'react-redux';
import { CalendarLoader } from '../../UI/CalendarLoader/CalendarLoader';

/**
 * Wrapper del calendario Studio.
 * Usa useSchedulerData per il data fetching e gestisce
 * il rendering condizionale (nessuno studio per il PdV).
 */
export const StudioCalendarInner = memo(
  function StudioCalendarInner(): JSX.Element {
    const { selectedDate, selectedPointOfSale } = useSelector(
      (state: RootState) => state.bluBookingStudioCalendar
    );

    const {
      calendarPointOfSale,
      shiftPointOfSale,
      getPointOfSaleStudi,
      isLoading,
    } = useSchedulerData({
      selectedDate,
      selectedPointOfSale,
    });

    const GetContent = useMemo(() => {
      if (isLoading) {
        return (
          <Stack
            alignItems="center"
            justifyContent="center"
            direction="row"
            flex="1"
            sx={{
              height: '100%',
              width: '100%',
              backgroundColor: 'var(--base-foreground-color) ',
            }}
          />
        );
      }
      if (
        !isLoading &&
        calendarPointOfSale !== undefined &&
        shiftPointOfSale !== undefined &&
        getPointOfSaleStudi().length === 0
      ) {
        return (
          <div style={{ height: '100%' }}>
            <Stack
              alignItems="center"
              justifyContent="center"
              direction="row"
              flex="1"
              sx={{ height: '100%', width: '100%' }}
            >
              <Typography fontWeight="bold">
                Nessuno studio per il punto vendita selezionato
              </Typography>
            </Stack>
          </div>
        );
      }
      return (
        <Scheduler
          calendarPointOfSale={calendarPointOfSale}
          shiftPointOfSale={shiftPointOfSale}
          studi={getPointOfSaleStudi()}
        />
      );
    }, [calendarPointOfSale, getPointOfSaleStudi, isLoading, shiftPointOfSale]);

    return (
      <div style={{ height: '100%' }}>
        {GetContent}
        <CalendarLoader open={isLoading} />
      </div>
    );
  }
);
